import { takeLatest } from 'redux-saga/effects'
import { FETCH_CHAT_LIMIT_SAGA } from 'src/store/types/adminData'
import fetchChatLimit from './fetchChatLimit'

export function* fetchChatLimitSaga() {
  yield takeLatest(FETCH_CHAT_LIMIT_SAGA, fetchChatLimit)
}
